export const createIfMissing = (
	wrapper,
	maybeExistingElement,
	id,
	className,
	text = '',
	hidden = false
) => {
	if (maybeExistingElement) return maybeExistingElement
	const el = document.createElement('div')
	if (hidden) el.classList.add('fws-hide')
	if (className) el.classList.add(className)
	el.id = id
	el.setAttribute('aria-live', 'polite')
	el.setAttribute('role', 'status')
	el.textContent = text
	wrapper.appendChild(el)
	return el
}

export const generateNonce = (len = 16) => {
	const arr = new Uint8Array(len)
	if (typeof crypto !== 'undefined' && crypto.getRandomValues)
		crypto.getRandomValues(arr)
	else for (let i = 0; i < len; i++) arr[i] = Math.floor(Math.random() * 256)
	return Array.from(arr)
		.map((b) => `0${b.toString(16)}`.slice(-2))
		.join('')
}

export const createSubmitHandler = (
	responsesMap,
	monotonicClockForElapsedTime,
	MINIMUM_SECONDS,
	_nonce
) => {
	return async (ev) => {
		ev.preventDefault()
		const form = ev.target
		if (!form.checkValidity()) {
			showResponse('error', responsesMap)
			form.reportValidity()
			return
		}
		const hp = form.querySelector('input[name="_hp"]')
		if (hp?.value && hp.value.trim() !== '') {
			showResponse('error', responsesMap)
			return
		}
		const nowMark =
			typeof performance !== 'undefined' && performance.now
				? performance.now()
				: Date.now()
		const elapsed = (nowMark - monotonicClockForElapsedTime) / 1000
		if (elapsed < MINIMUM_SECONDS) {
			showResponse('error', responsesMap)
			return
		}
		const submitBtn = form.querySelector('button[type="submit"]')
		submitBtn.disabled = true
		submitBtn.textContent = 'Sending…'
		const payload = serialize(form)
		payload._elapsed_seconds = Math.round(elapsed)
		payload._nonce = _nonce
		try {
			const DEBUG = false
			let response
			if (!DEBUG) {
				response = await fetch(endpoint, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Origin: window.location.origin,
					},
					body: JSON.stringify(payload),
				})
			} else {
				response = {
					ok: true,
					json: async () => 'debugging',
				}
			}
			if (response.ok) {
				const _data = await response.json()
				console.log('response ok', _data)
				showResponse('success', responsesMap)
				form.reset()
				const elementsToFade = form.querySelectorAll('.will-fade')
				elementsToFade.forEach((el) => {
					el.style.transition =
						el.style.transition || 'opacity 360ms ease, transform 360ms ease'
					requestAnimationFrame(() => {
						el.style.opacity = '0'
						el.style.transform = 'translateY(-6px)'
						el.style.pointerEvents = 'none'
					})
				})
				try {
					setTimeout(() => {
						elementsToFade.forEach((el) => {
							el.style.display = 'none'
							return
						})
						showResponse('success', responsesMap) // re-show if needed
					}, 420)
				} catch {
					//noop
				}
			} else {
				showResponse('failed', responsesMap)
				const text = await response.text()
				console.warn('submission error', response.status, text)
			}
		} catch (err) {
			showResponse('error', responsesMap)
			console.error(err)
		} finally {
			submitBtn.disabled = false
			submitBtn.textContent = 'Submit application'
		}
	}
}

export const serialize = (form) => {
	const data = {}
	const elementsGroupedByName = {}
	for (const el of form.elements) {
		if (!el.name || el.disabled) continue
		if (!elementsGroupedByName[el.name]) elementsGroupedByName[el.name] = []
		elementsGroupedByName[el.name].push(el)
	}
	for (const name in elementsGroupedByName) {
		const group = elementsGroupedByName[name]
		const first = group[0]
		const tag = (first.tagName || '').toLowerCase()
		const type = (first.type || '').toLowerCase()
		if (type === 'checkbox') {
			if (group.length === 1) {
				data[name] = !!first.checked
			} else {
				const vals = []
				for (const el of group) if (el.checked) vals.push(el.value)
				if (vals.length) data[name] = vals
			}
			continue
		}
		if (type === 'radio') {
			const checked = group.find((el) => el.checked)
			if (checked) data[name] = checked.value
			continue
		}
		if (tag === 'select' && first.multiple) {
			const vals = Array.from(first.options)
				.filter((o) => o.selected)
				.map((o) => o.value)
			if (vals.length) data[name] = vals
			continue
		}
		if (group.length === 1) {
			data[name] = first.value
		} else {
			data[name] = group.map((el) => el.value)
		}
	}
	return data
}

export const showResponse = (elementName, elementsMap) => {
	for (const el of Object.values(elementsMap)) {
		if (!el) continue
		el.classList.add('fws-hide')
	}
	const el = elementsMap[elementName]
	if (el) {
		el.classList.remove('fws-hide')
		el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
	}
	return
}

const endpoint = 'https://betterteamsacademy.vercel.app/api/relay'
const MINIMUM_SECONDS = 10

document.addEventListener('DOMContentLoaded', () => {
	const monotonicClockForElapsedTime =
		typeof performance !== 'undefined' && performance.now
			? performance.now()
			: Date.now()
	const form = document.getElementById('mail_form')
	const wrapper = createIfMissing(
		form,
		document.getElementById('fws-responses'),
		'fws-responses',
		'fws-responses',
		null,
		false
	)
	const responsesMap = {
		success: createIfMissing(
			wrapper,
			document.getElementById('fws-response-success'),
			'fws-response-success',
			null,
			'Message received.',
			true
		),
		failed: createIfMissing(
			wrapper,
			document.getElementById('fws-response-failed'),
			'fws-response-failed',
			null,
			'Submission failed. Something went wrong.',
			true
		),
		error: createIfMissing(
			wrapper,
			document.getElementById('fws-response-error'),
			'fws-response-error',
			null,
			'Something went wrong. Check all required form elements.',
			true
		),
	}
	const _nonce = generateNonce(16)
	const nonceInput = document.createElement('input')
	nonceInput.type = 'hidden'
	nonceInput.name = '_nonce'
	nonceInput.value = _nonce
	form.appendChild(nonceInput)
	const honeypot = document.createElement('input')
	honeypot.autocomplete = 'off'
	honeypot.name = '_hp'
	honeypot.style.cssText =
		'position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;'
	honeypot.tabindex = '-1'
	honeypot.type = 'text'
	form.appendChild(honeypot)
	form.addEventListener(
		'submit',
		createSubmitHandler(
			responsesMap,
			monotonicClockForElapsedTime,
			MINIMUM_SECONDS,
			_nonce
		)
	)
})
